import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  create(attrs) {
    const url = apiRoutes.signInPath();

    return FetchHelpers.post(url, attrs);
  },
  destroy() {
    const url = apiRoutes.signOutPath();

    return FetchHelpers.delete(url);
  },
  updatePassword(attrs) {
    const url = apiRoutes.authPasswordPath();

    return FetchHelpers.put(url, attrs);
  },
  updateBuyer(attrs) {
    const url = apiRoutes.buyerSettingsPath();

    return FetchHelpers.post(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/SessionRepository.js